<template>
  <section class="relative w-full">
    <!-- Desktop version Banner cover Section -->
    <div
      class="relative md:block hidden w-full overflow-hidden md:bg-center bg-no-repeat bg-right md:bg-contain about-us-hero-bg-section h-[632px] md:lg:h-[740px] lg:h-[880px] xl:block"
    >
      <div class="h-[480px] md:h-[497px] lg:h-[560px] xl:h-[740px]">
        <div
          class="container md:relative md:top-0 absolute top-[120px] xl:pt-[70px] md:pb-[100px] lg:pb-0 xl:pb-[84px]"
        >
          <div
            class="border-b-4 skew-x-[-50deg] w-[108px] h-1 lg:h-[6px] absolute md:mt-5 lg:mt-[99px] mb-[31px]"
            style="border-color: #f1d4b5"
          />
          <h1
            class="text-[28px] lg:text-[44px] leading-[34px] xl:text-[52px] font-OPPO-sans-bold w-[299px] md:w-[320px] lg:w-[510px] xl:w-[587px] lg:leading-[52px] xl:leading-[58px] text-start text-white mt-[10%] xl:mt-0 md:pt-12 lg:pt-[145px]"
          >
            {{
              $t("common.benda.about_us_main_title", {
                benda_brand: "Benda ",
                keeway_brand: "keeway ",
                interpolation: { prefix: "[:", suffix: "]" },
              })
            }}
          </h1>
          <p
            class="text-[15px] md:text-lg xl:text-[20px] font-OPPO-sans-regular w-[299px] md:w-[340px] lg:w-[450px] xl:w-[540px] leading-normal font-light text-start text-white pt-[33px]"
          >
            {{
              $t("common.benda.about_us_main_description", {
                benda_brand: "Benda ",
                keeway_brand: "keeway ",
                interpolation: { prefix: "[:", suffix: "]" },
              })
            }}
          </p>
        </div>
      </div>
    </div>
    <!-- Mobile Version Banner cover Section-->
    <div class="block lg:hidden md:hidden">
      <div
        class="relative"
        data-aos="fade-left"
        data-aos-delay="100"
        data-aos-offset="100"
      >
        <img
          class="relative w-full h-[480px] object-cover object-top"
          src="@/assets/images/about-us/about-us-hero-banner-mobile.png"
          alt=""
          loading="lazy"
        />
      </div>
      <div
        style="background: #191919"
        class="flex items-center justify-start order-2 px-4 pt-[30px] pb-[60px] overflow-hidden md:w-1/2"
        data-aos="fade-left"
        data-aos-delay="100"
      >
        <div class="w-auto">
          <div
            class="border-b-4 w-[108px] skew-x-[-50deg] flex justify-start items-start text-start h-1 lg:h-[6px] mb-[16px]"
            style="border-color: #f1d4b5"
          />
          <h1
            class="text-[28px] font-OPPO-sans-bold w-[345px] sm:w-full tracking-[-2%] leading-[36px] font-normal text-start text-white"
          >
            {{
              $t("common.benda.about_us_main_title", {
                benda_brand: "Benda ",
                keeway_brand: "keeway ",
                interpolation: { prefix: "[:", suffix: "]" },
              })
            }}
          </h1>
          <p
            class="text-[15px] xl:text-[20px] xl:leading-normal mt-[10px] text-white leading-[24px] font-OPPO-sans-regular font-light"
          >
            {{
              $t("common.benda.about_us_main_description", {
                benda_brand: "Benda ",
                keeway_brand: "keeway ",
                interpolation: { prefix: "[:", suffix: "]" },
              })
            }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<style>
.about-us-hero-bg-section {
  background-image: url("@/assets/images/about-us/about-us-hero-bg-img.png");
  background-repeat: no-repeat;
  background-position: center center;
  @apply md:bg-cover;
}
</style>
